var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"w-full bgImg",attrs:{"src":_vm.baseOSSUrl + '/banner1.png',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }